import React from "react";

import { defaultSettings } from "./defaults/settings";
import Component from "./Component";
import Form from "./Form/AccordionForm";

const createPlugin = (settings) => {
    const mergedSettings = { ...defaultSettings, ...settings };

    return {
        Component: (props) => <Component {...props} {...mergedSettings} />,
        FormComponent: (props) => <Form {...props} />,

        name: "peracto/content/accordion",
        version: "1.0.0",
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            label: mergedSettings.defaultLabel,
            accordion: [],
            selectedAccordionIndex: 0,
            headerColour: "#000000",
            headerFontSize: 3,
            headerBackgroundColour: "transparent",
            headerFont: "body",
            headerFontWeight: "normal",
        }),
    };
};

export default createPlugin;
